import Ryan from './img/Ryan.png';
import Flynn from './img/Flynn.png';
import Lois from './img/Lois.png';
import Mingshan from './img/Mingshan.png';
import Valerie from './img/Valerie.png';

const DevOps = [
  {
    image: Ryan,
    name: 'Ryan Xu',
    position: 'DevOps Team Leader',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/yannan-xu'
  },
  {
    image: Flynn,
    name: 'Flynn Diao',
    position: 'DevOps',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://linkedin.com/in/yuchen-diao-63644b20a'
  },
  {
    image: Lois,
    name: 'Lois Gu',
    position: 'DevOps',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/lois-zhiyu-gu'
  },
  {
    image: Mingshan,
    name: 'Mingshan You',
    position: 'DevOps',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/mingshan-you'
  },
  {
    image: Valerie,
    name: 'Valerie Qi',
    position: 'DevOps',
    bulletPoint1: 'Lorem, ipsum dolor',
    bulletPoint2: 'Lorem, ipsum dolor',
    bulletPoint3: 'Lorem, ipsum dolor',
    LinkedinURL: 'https://www.linkedin.com/in/valerie-yang-894607234'
  }
];

export default DevOps;
